import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveMyProjects(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const topFolders = await axios.get('/autodesk/data-management/data-management/projects', config);
        return topFolders.data;
      } catch (error) {
        throw error;
      }
    },
    async retrieveTopFolders(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const topFolders = await axios.get(`/autodesk/data-management/data-management/projects/${data.projectId}/top-folders`, config);
        return topFolders.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
